import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

interface GraphPoint {
  x: string;
  y: number;
}

interface Result {
  graphData?: GraphPoint[] | null;
  average?: number | null;
  loading: boolean;
  error?: string;
}

export const useSessionLatency = (
  username?: string,
  year?: string,
  quarter?: number,
  enabled: boolean = true
): Result => {
  const client = useMyProviderDataClient();

  const [graphData, setGraphData] = useState<GraphPoint[] | null>();
  const [average, setAverage] = useState<number | null>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !username || !year) return;

    const load = async () => {
      try {
        setLoading(true);

        const res = await client.get(
          "/EmployeeInformation/SessionLatency",
          { params: { username, year, quarter } }
        );

        const data = res.data;

        let formatted: GraphPoint[] = [];
        let count = 0;
        let sum = 0;

        data.forEach((week: any) => {
          const start = new Date(week.startDate);
          const end = new Date(week.endDate);

          const label = `${start.getMonth() + 1}/${start.getDate()}-${end.getMonth() + 1}/${end.getDate()}`;

          const value = week.latency ?? 0;

          if (week.latency != null) {
            count++;
            sum += week.latency;
          }

          formatted.push({ x: label, y: value });
        });

        const avg = count > 0 ? sum / count : null;

        const allZero = formatted.every(w => w.y === 0);

        if (allZero) {
          setGraphData(null);
          setAverage(null);
        } else {
          setGraphData(formatted);
          setAverage(avg);
        }

      } catch (err) {
        console.error(err);
        setGraphData(null);
        setAverage(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [username, year, quarter, enabled, client]);

  return { graphData, average, loading };
};